import React, { useRef } from 'react'
import {  Image, Button } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import img1 from "../../../assets/images/tem.png"
import "./index.scss"
import { SliderIconLeft } from '../../../assets/icons/SliderIconLeft';
import { SliderIconRight } from '../../../assets/icons/SliderIconRight';
export const Temoignage = () => {
        const sliderRef = useRef(null);
        const temoignage = [
  {
    name: 'Claire Montel',
    description: "Consultek a transformé notre SI en 6 mois. Une expertise rare et une réactivité exceptionnelle.",

    image: img1,

  },  {
    name: 'Claire Montel',
    description: "Consultek a transformé notre SI en 6 mois. Une expertise rare et une réactivité exceptionnelle.",

    image: img1,

  },  {
    name: 'Claire Montel',
    description: "Consultek a transformé notre SI en 6 mois. Une expertise rare et une réactivité exceptionnelle.",

    image: img1,

  },
  {
    name: 'Claire Montel',
    description: "Consultek a transformé notre SI en 6 mois. Une expertise rare et une réactivité exceptionnelle.",

    image: img1,

  },

];
      const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 500,
    arrows: false, // Direction de droite à gauche
    pauseOnHover: true,
    responsive: [
             {
        breakpoint: 1500, // En dessous de 768px (mobile)
        settings: {
          slidesToShow: 3, // Affiche 3 drapeaux
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // En dessous de 768px (mobile)
        settings: {
          slidesToShow: 2, // Affiche 3 drapeaux
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // En dessous de 480px (petit mobile)
        settings: {
          slidesToShow: 1, // Affiche 2 drapeaux
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className='mt-5 mb-5'>       <Slider {...settings}   ref={sliderRef} >
        {temoignage.map((member, index) => (

           <div className="testimonial-card ">
            <div className=' d-flex align-items-center mb-3  gap-4'>
              <Image
                src={member?.image}
                alt="Claire Montel"
                roundedCircle
                className="avatar"
              />

              <div>
                <h4 className="mb-3 ">Claire Montel</h4>
            </div>
              </div>
                  <p className="mb-0 ">
                  Consultek a transformé notre SI en 6 mois. Une expertise rare
                  et une réactivité exceptionnelle.
                </p>
            </div>
 
        ))}</Slider>
             <div className="navigation-arrows d-flex mt-4">
            <button
              className="me-2 nav-circle"
              onClick={() => sliderRef.current.slickPrev()}>
            <SliderIconLeft />
            </button>
            <button
              className="nav-circle"
              onClick={() => sliderRef.current.slickNext()}>
   <SliderIconRight />
            </button>
          </div>{" "}</div>
  )
}
